import type { Workflow, WorkflowConfig } from "@structurify/shared-types";

const API_URL = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "https://api.structurify.dscvry.ai";

export type { Workflow };

export async function createWorkflow(session: string, name: string, config: WorkflowConfig): Promise<Workflow> {
  const res = await fetch(`${API_URL}/api/workflows`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session}` },
    body: JSON.stringify({ name, config }),
  });
  if (!res.ok) {
    const data = await res.json() as { error?: string };
    throw new Error(data.error ?? `Failed: ${res.status}`);
  }
  return res.json() as Promise<Workflow>;
}

export async function listWorkflows(session: string): Promise<Workflow[]> {
  const res = await fetch(`${API_URL}/api/workflows`, {
    headers: { "Authorization": `Bearer ${session}` },
  });
  if (!res.ok) return [];
  return res.json() as Promise<Workflow[]>;
}

export async function deleteWorkflow(session: string, id: string): Promise<void> {
  await fetch(`${API_URL}/api/workflows/${id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${session}` },
  });
}
